import type { User } from 'api/generated';

export const hasAdditionalInformation = (user: User) => {
  const {
    first_name,
    last_name,
    birth_date,
  }: { first_name?: string | null; last_name?: string | null; birth_date?: string | null } = user;
  return [
    first_name && first_name !== '',
    last_name && last_name !== '',
    birth_date && (typeof birth_date === 'string' ? birth_date !== '' : true),
  ].every((valid) => valid === true);
};
